/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/views/web/product/conponents/ProductDesc/index.tsx
 * @Description: 商品详情页推荐商品卡片
 */
import React from 'react';
import useUrl from '@/hooks/useUrl';
import styles from './index.module.scss';
import { IDesc } from '../../product';
interface IProps {
  attachment: IDesc[];
  detailContentOfHtml: string;
}
const DescIterm = (props: { productDesc: IDesc }) => {
  const { getPublicUrl } = useUrl();
  const { detailTypeName, content, contentType } = props.productDesc;
  return (
    <div className={styles.desc_item}>
      <div className={styles.desc_type_name}>{detailTypeName}</div>
      {contentType === 0 ? (
        <div className={styles.desc_content}>
          <img src={getPublicUrl(content)} className={styles.desc_img} />
        </div>
      ) : contentType === 1 ? (
        <div className={styles.detail_info}>{content}</div>
      ) : null}
    </div>
  );
};
const ProductDesc = (props: IProps) => {
  return !!props?.attachment?.length ? (
    <div className={styles.recomend_container}>
      {props?.attachment?.map((item) => (
        <DescIterm key={item.content} productDesc={item} />
      ))}
    </div>
  ) : props.detailContentOfHtml ? (
    <div
      dangerouslySetInnerHTML={{
        __html: props.detailContentOfHtml,
      }}
      className={styles.content_html}
    />
  ) : null;
};

export default ProductDesc;
